<template>
    <span>
        <button :class="{
                'btn': true, 
                'btn-app': true,
                'dropdown-toggle': isDropdown,
            }"
            :data-toggle="isDropdown ? 'dropdown' : null" 
            :aria-haspopup="isDropdown ? 'true' : null" 
            :aria-expanded="isDropdown ? 'false' : null"
            @click="handleClick"
            v-if="hasVisibleChild">
            <span v-if="internalBadgeContent"
                :class="`badge bg-${badgeColor}`">
                {{ internalBadgeContent }}
            </span>
            <i v-if="icon" :class="`fa fa-${icon}`" /> {{ label }}
        </button>
        <ul class="dropdown-menu" v-if="isDropdown">
            <li v-for="(menu, index) in subMenus" :key="index" v-show="menu.show">
                <x-app-button-item :item="menu" />
            </li>
        </ul>
    </span>
</template>

<script>
import { emptyPromise } from '../helpers'
export default {
    computed: {
        isDropdown() {
            return this.subMenus.length > 0
        },
        hasVisibleChild() {
            return this.subMenus.reduce((state, subMenu) => {
                return state && subMenu.show
            }, true)
        },
    },
    created() {
        this.handleBadgeCallback()
    },
    data() {
        return {
            internalBadgeContent: null,
        }
    },
    methods: {
        handleBadgeCallback() {
            this.badgeCallback().then(response => {
                this.internalBadgeContent = _.get(response, 'data.data', null)
            })
        },
        handleClick() {
            if (this.url) {
                this.$router.push(this.url)
            }
        },
    },
    props: {
        badgeCallback: {
            type: Function,
            required: false,
            default: () => {
                return emptyPromise()
            },
        },
        badgeColor: {
            type: String,
            required: false,
            default: 'red',
        },
        icon: {
            type: String,
            required: false,
            default: null,
        },
        label: {
            type: String,
            required: false,
            default: null,
        },
        subMenus: {
            type: Array,
            required: false,
            default: () => [],
        },
        url: {
            type: String,
            required: false,
            default: null,
        },
    },
}
</script>